import {mixins} from "../app/mixin";

mixins.push({
    el: '.sdgLandingWrapper',
    data() {
        return {
            selectedStep: 1,
            selectedBenefit: 1,
        }
    },
    methods: {
        selectStep(stepId) {
            if (this.selectedStep !== stepId) {
                this.selectedStep = stepId
            }
        },
        selectBenefit(benefitId) {
            if (this.selectedBenefit !== benefitId) {
                this.selectedBenefit = benefitId
            }
        },
    },
});